(function () {
    'use strict';

    angular
        .module(app.modules.app.name)
        .config(resourceConfig);

    // The $resource is missing an "update" method.  Also, I added an alias for "$save" called "$insert" to avoid confusion (they
    // do the same thing).  Also, it supports interceptors but only for response and responseError.  I added support for a 
    // request interceptor primarily so we can modify headers dynamically.

    resourceConfig.$inject = ['$provide', '$resourceProvider', '$httpProvider', '$sceDelegateProvider'];
    function resourceConfig($provide, $resourceProvider, $httpProvider, $sceDelegateProvider, inputDirectiveProvider) {
        $resourceProvider.defaults.transformResponse = [].concat($httpProvider.defaults.transformResponse, transformResponse);
        $resourceProvider.defaults.actions.update = { method: 'PUT' };
        $resourceProvider.defaults.actions.insert = { method: 'POST' };
        $resourceProvider.defaults.actions.patch = { method: 'PATCH' };

        $provide.decorator('$resource', resourceDecorator)
        $httpProvider.interceptors.push(resourceInterceptor);

        function transformResponse(response, headers, status) {
            return response.value || response;
        }

        resourceDecorator.$inject = ['$delegate'];
        function resourceDecorator($delegate) {
            return angular.extend($resourceProxy, { defaults: $resourceProvider.defaults });

            function $resourceProxy(url, paramDefaults, actions, options) {
                actions = angular.extend({}, $resourceProvider.defaults.actions, actions);
                angular.forEach(actions, function (action, name) {
                    action.transformResponse = action.transformResponse || $resourceProvider.defaults.transformResponse;
                    action.$interceptor = action.interceptor;
                    action.resolveDates = true;
                });
                return $delegate(url, paramDefaults, actions, options);
            }
        }

        resourceInterceptor.$inject = ['$q']
        function resourceInterceptor($q) {
            return { request: requestInterceptor };

            function requestInterceptor(config) {
                var interceptor = config && config.$interceptor || {};
                return $q.when(config).then(interceptor.request);
            }
        }
    }
})();